import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../users-module/services/user.service';
import { ScreeningService } from '../../screening-module/services/screening.service';
import { ClientService } from '../../clients-module/services/client.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { SearchPackage } from '../models/searchPackage';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { PaginationEventData } from 'src/app/shared-components-module/pagination-top/models/paginationEventData';
import { SimpleDataFilter } from 'src/app/models/simpleDataFilter';
import { FilteringService } from 'src/app/services/filtering.service';

@Component({
    selector: 'app-packages',
    templateUrl: './packages.component.html',
    styleUrls: ['./packages.component.less']
})
export class PackagesComponent implements OnInit, OnDestroy {
    ngOnDestroy(): void {
        this.packages._searchPackages = [];
    }
    constructor(public auth: AuthService,
        public users: UserService,
        public screening: ScreeningService,
        public clients: ClientService,
        public toast: ToastrService,
        public location: Router,
        public filtering: FilteringService,
        public packages: SearchPackageService,
        public activatedRoute: ActivatedRoute) {
    }

    public ngOnInit(): void {
        this.packages.FetchSearchPackagesList();
    }

    public onPaginationChanged(event: PaginationEventData) {
        this.filtering.filters.push(new SimpleDataFilter('offsetCount', event.offset.toString(), true));
        this.packages._searchPackages = [];
        this.packages.FetchSearchPackagesList();
        this.filtering.clearTransientFilters();
    }

    public navigate(path: string): void {
        this.location.navigateByUrl(path);
    }

    public viewPackage(pkg: SearchPackage, edit: boolean = false): void {
        if (edit) {
            this.location.navigateByUrl(`packages/edit/${pkg.id}`);
        } else {
            this.location.navigateByUrl(`packages/review/${pkg.id}`);
        }
    }
}
